import Paper from '@mui/material/Paper';

import {  styled } from '@mui/material/styles';

export const Container = styled(Paper)(({ theme, color }) => ({
  minWidth: 150,
  padding: 16,
  display: 'flex',
  alignItems: 'baseline',
  flexDirection: 'column',
  rowGap: 4,

  '.icon-container': {
    width: 42,
    height: 42,
    marginBottom: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: color || theme.palette.primary.main,
    borderRadius: '100px',

    '> svg': {
      color: 'white',
    }
  },

  '> strong': {
    fontSize: '1.125rem',
  },

  '> p': {
    fontSize: '0.875rem',
    fontWeight: 300,
    margin: 0,
  }
}));
